import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setUnReadNotificationCount } from "store/common/commonSlice.js";
import { Get } from "../axios/AxiosFunctions.js";
import { BaseURL } from "../config/apiUrl";
import { updateUser } from "../store/auth/authSlice";

export const useGetMe = () => {
  const [isLoading, setIsLoading] = useState(false);
  const { isLogin, access_token } = useSelector(
    (state) => state.authAdminReducer
  );
  const dispatch = useDispatch();

  const getMe = async () => {
    const apiUrl = BaseURL("users/me");
    const notificationUrl = BaseURL("notifications/unreadCount");
    setIsLoading(true);
    const [userRes, notificationRes, catRes] = await Promise.allSettled([
      Get(apiUrl, access_token, false, dispatch),
      Get(notificationUrl, access_token, false, dispatch),
    ]);
    if (userRes?.value || notificationRes?.value || catRes?.value) {
      dispatch(updateUser(userRes?.value?.data?.data?.user));
      dispatch(
        setUnReadNotificationCount(
          notificationRes?.value?.data?.data?.unReadCount
        )
      );
    }
    setIsLoading(false);
  };

  useEffect(() => {
    if (isLogin) {
      getMe();
    }
  }, [isLogin]);
  return isLoading;
};
